import React, { useEffect, useState } from "react";
import Style from "./index.module.scss";

interface Props {
    data: string;
}
const Index = ({ data }: Props) => {
    const [list, setList] = useState<string[]>([]);
    useEffect(() => {
        setList(data.split(","));
    }, [data]);
    return (
        <ul className={Style.root}>
            {list.map((item, index) => {
                return <li key={item + index}>{item}</li>;
            })}
        </ul>
    );
};

export default Index;
